import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { solid } from "@fortawesome/fontawesome-svg-core/import.macro";
import andiamoLogo from "../../assets/andiamo_round.png";
import "./WelcomeScreen.css";

// First-run screen for signed-out visitors with no explicit ?id= (i.e. not a
// shared link). Gates the app's render tree in App.js — see ShowWelcomeScreen.
// Doesn't load anything itself: the sample guide is already loading in the
// background (MobileBottomNavBar.js's onAuthStateChanged), this is a UI gate
// on top of that, dismissed by whichever action the visitor picks.
const WelcomeScreen = () => {
  const dispatchAction = (action) => {
    window.dispatchEvent(new CustomEvent("welcomeScreenAction", { detail: { action } }));
  };

  const signIn = () => {
    window.dispatchEvent(new CustomEvent("openLoginModal", { detail: { mode: "Login" } }));
  };

  return (
    <div className="welcome-screen">
      <div className="welcome-screen-content">
        <img className="welcome-screen-mark" src={andiamoLogo} alt="Andiamo Places" />
        <h1 className="welcome-screen-title">
          Every trip starts
          <br />
          with a first pin.
        </h1>
        <p className="welcome-screen-subtitle">
          Completely free. Plans your schedule around real opening hours, so you're never sent to a closed museum.
        </p>
        <div className="welcome-screen-actions">
          <button className="welcome-screen-btn welcome-screen-btn-primary" onClick={() => dispatchAction("blank")}>
            <FontAwesomeIcon icon={solid("route")} />
            Build My Trip
          </button>
          <button className="welcome-screen-btn welcome-screen-btn-secondary" onClick={() => dispatchAction("featured")}>
            Browse featured guides
          </button>
          <button className="welcome-screen-btn welcome-screen-btn-secondary" onClick={() => dispatchAction("blank-manual")}>
            Start with a Blank Guide
          </button>
        </div>
        <button className="welcome-screen-signin" onClick={signIn}>
          Already have an account? <span className="welcome-screen-signin-link">Sign In</span>
        </button>
      </div>

      <div className="welcome-screen-visual" aria-hidden="true">
        <div className="welcome-screen-visual-glow" />
        <svg className="welcome-screen-route" viewBox="0 0 520 620" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path
            className="welcome-screen-route-path"
            d="M70 90 C 180 40, 230 160, 160 230 S 60 340, 150 400 S 340 380, 330 480 S 430 560, 460 540"
            stroke="#B8500A"
            strokeWidth="3"
            strokeLinecap="round"
            strokeDasharray="8 10"
          />
          <g className="welcome-screen-pin welcome-screen-pin-1">
            <circle cx="70" cy="90" r="7" fill="#B8500A" />
            <circle cx="70" cy="90" r="14" stroke="#B8500A" strokeOpacity="0.45" strokeWidth="1.5" />
          </g>
          <g className="welcome-screen-pin welcome-screen-pin-2">
            <circle cx="160" cy="230" r="5" fill="#C2661F" />
          </g>
          <g className="welcome-screen-pin welcome-screen-pin-3">
            <circle cx="150" cy="400" r="5" fill="#C2661F" />
          </g>
          <g className="welcome-screen-pin welcome-screen-pin-4">
            <circle cx="460" cy="540" r="8" fill="#B8500A" />
            <circle cx="460" cy="540" r="16" stroke="#B8500A" strokeOpacity="0.45" strokeWidth="1.5" />
          </g>
        </svg>
        {/* Wide version of the route for the short banner on narrow screens
            (shown only below 981px — see WelcomeScreen.css). The tall route
            above shrank to a small blob there, mostly hidden by the cards.
            Same path/pins as mobile's WelcomeOverlay.js. 2026-10-10. */}
        <svg className="welcome-screen-route-wide" viewBox="0 0 400 160" preserveAspectRatio="xMidYMid meet" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path
            className="welcome-screen-route-path"
            d="M24 120 C 70 60, 110 150, 150 100 S 220 40, 260 90 S 330 130, 376 60"
            stroke="#B8500A"
            strokeWidth="2.5"
            strokeLinecap="round"
            strokeDasharray="8 10"
          />
          <g className="welcome-screen-pin welcome-screen-pin-1">
            <circle cx="24" cy="120" r="7" fill="#B8500A" />
            <circle cx="24" cy="120" r="14" stroke="#B8500A" strokeOpacity="0.45" strokeWidth="1.5" />
          </g>
          <g className="welcome-screen-pin welcome-screen-pin-2">
            <circle cx="150" cy="100" r="5" fill="#C2661F" />
          </g>
          <g className="welcome-screen-pin welcome-screen-pin-3">
            <circle cx="260" cy="90" r="5" fill="#C2661F" />
          </g>
          <g className="welcome-screen-pin welcome-screen-pin-4">
            <circle cx="376" cy="60" r="8" fill="#B8500A" />
            <circle cx="376" cy="60" r="16" stroke="#B8500A" strokeOpacity="0.45" strokeWidth="1.5" />
          </g>
        </svg>
        <div className="welcome-screen-card-float welcome-screen-card-float-1">
          <FontAwesomeIcon icon={solid("route")} />
          <div>
            <div className="wscf-title">4-day Kyoto</div>
            <div className="wscf-sub">12 places · 3 days planned</div>
          </div>
        </div>
        <div className="welcome-screen-card-float welcome-screen-card-float-2">
          <FontAwesomeIcon icon={solid("image")} />
          <div>
            <div className="wscf-title">Journal ready</div>
            <div className="wscf-sub">86 photos organized</div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default WelcomeScreen;
